import s from "~/pages/Editor/EditorDocumentSection/s.less";
import Button from "~/shared/ui/Fields/Button";
import Modal from "~/shared/ui/Fields/Modal";
import React, { useContext } from "react";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import { useTranslation } from "react-i18next";
import {
  useAddNotificationMutation,
  useDeleteCameraMutation,
} from "~/schemas/generated/graphql";
import { NOTIFICATIONS } from "~/constans/notifications";
import { CamerasContext } from "~/pages/CameraZonesView";

const DeleteCameraModal = () => {
  const { t } = useTranslation();
  const { openModal, currentId } = useURLParamsGetter<{
    openModal: string;
    currentId: string;
  }>();
  const setParams = useURLParamsSetter();
  const { fetchCameras } = useContext(CamerasContext);

  const [addNotificator] = useAddNotificationMutation();
  const [deleteCameraZone, deleteCameraZoneState] = useDeleteCameraMutation({
    onCompleted: () => {
      addNotificator({
        variables: {
          type: NOTIFICATIONS.success,
          content: "Камера удалена",
        },
      });
      fetchCameras();
      closeModal();
    },
  });
  const closeModal = () => setParams({ openModal: undefined });

  const removeHandle = () =>
    deleteCameraZone({
      variables: { id: currentId },
    });

  return (
    <Modal
      isOpen={openModal === "Sure"}
      title={"Удалить камеру"}
      actionClose={closeModal}
      customClassName={s.styleModel}
    >
      <div className={s.controlWrapper}>
        <Button onClick={removeHandle} txtBtn={t("ui.delete")} isForm />
        <Button onClick={closeModal} txtBtn={t("ui.cancel")} isForm />
      </div>
    </Modal>
  );
};

export default DeleteCameraModal;
